import createIcon from '../../createIcon';

/**
 * @component @name Attachment
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMiAxMkMyIDguOTYgNC40NiA2LjUgNy41IDYuNUgxOEMyMC4yMSA2LjUgMjIgOC4yOSAyMiAxMC41QzIyIDEyLjcxIDIwLjIxIDE0LjUgMTggMTQuNUg5LjVDOC4xMiAxNC41IDcgMTMuMzggNyAxMkM3IDEwLjYyIDguMTIgOS41IDkuNSA5LjVIMTdWMTEuNUg5LjQxQzguODYgMTEuNSA4Ljg2IDEyLjUgOS40MSAxMi41SDE4QzE5LjEgMTIuNSAyMCAxMS42IDIwIDEwLjVDMjAgOS40IDE5LjEgOC41IDE4IDguNUg3LjVDNS41NyA4LjUgNCAxMC4wNyA0IDEyQzQgMTMuOTMgNS41NyAxNS41IDcuNSAxNS41SDE3VjE3LjVINy41QzQuNDYgMTcuNSAyIDE1LjA0IDIgMTJaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Attachment = createIcon('Attachment', [
  [
    'path',
    {
      d: 'M2 12C2 8.96 4.46 6.5 7.5 6.5H18C20.21 6.5 22 8.29 22 10.5C22 12.71 20.21 14.5 18 14.5H9.5C8.12 14.5 7 13.38 7 12C7 10.62 8.12 9.5 9.5 9.5H17V11.5H9.41C8.86 11.5 8.86 12.5 9.41 12.5H18C19.1 12.5 20 11.6 20 10.5C20 9.4 19.1 8.5 18 8.5H7.5C5.57 8.5 4 10.07 4 12C4 13.93 5.57 15.5 7.5 15.5H17V17.5H7.5C4.46 17.5 2 15.04 2 12Z',
      key: '1z068o',
    },
  ],
]);

export default Attachment;
